module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.register($event)
      }
    }
  }, [_c('md-input-container', [_c('label', [_vm._v("First Name")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "required": ""
    },
    model: {
      value: (_vm.newUser.firstName),
      callback: function($$v) {
        _vm.$set(_vm.newUser, "firstName", $$v)
      },
      expression: "newUser.firstName"
    }
  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("Last Name")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "required": ""
    },
    model: {
      value: (_vm.newUser.lastName),
      callback: function($$v) {
        _vm.$set(_vm.newUser, "lastName", $$v)
      },
      expression: "newUser.lastName"
    }
  })], 1), _vm._v(" "), _c('md-input-container', {
    class: {
      'md-input-invalid': _vm.emailError()
    }
  }, [_c('label', [_vm._v("Email")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "type": "email",
      "required": ""
    },
    model: {
      value: (_vm.newUser.email),
      callback: function($$v) {
        _vm.$set(_vm.newUser, "email", $$v)
      },
      expression: "newUser.email"
    }
  }), _vm._v(" "), (_vm.emailError) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(_vm.errorMessage))]) : _vm._e()], 1), _vm._v(" "), _c('md-input-container', {
    class: {
      'md-input-invalid': _vm.passwordError()
    }
  }, [_c('label', [_vm._v("Password")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "type": "password",
      "required": ""
    },
    model: {
      value: (_vm.newUser.password),
      callback: function($$v) {
        _vm.$set(_vm.newUser, "password", $$v)
      },
      expression: "newUser.password"
    }
  }), _vm._v(" "), (_vm.passwordError) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(_vm.errorMessage))]) : _vm._e()], 1), _vm._v(" "), _c('md-input-container', {
    class: {
      'md-input-invalid': _vm.confirmPasswordError()
    }
  }, [_c('label', [_vm._v("Confirm Password")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "type": "password",
      "required": ""
    },
    model: {
      value: (_vm.newUser.confirmPassword),
      callback: function($$v) {
        _vm.$set(_vm.newUser, "confirmPassword", $$v)
      },
      expression: "newUser.confirmPassword"
    }
  }), _vm._v(" "), (_vm.confirmPasswordError) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v("Passwords do not match")]) : _vm._e()], 1), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised md-primary",
    on: {
      "click": _vm.register
    }
  }, [_c('md-icon', [_vm._v("person")]), _vm._v(" Register")], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6a6aabb7","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./sample/components/auth/register-form.vue
// module id = 658
// module chunks = 2